// hooks/emailService.js

import axios from "axios";
import config from "../../devprodConfig";

const API_URL = config.apiBaseUrl;

export const sendReportEmail = async ({
  to,
  subject,
  body,
  fileBase64,
  filename,
  sharePointAttachments = []
}) => {
  const { data } = await axios.post(
    `${API_URL}/api/email/send-email-graph`,
    {
      to,
      subject,
      body,
      fileBase64,
      filename,
      sharePointAttachments
    },
    { withCredentials: true }
  );

  return data;
};